import { forwardRef, PropsWithChildren } from 'react';

import { LoadingButtonProps } from '@mui/lab';
import LoadingButton from '@mui/lab/LoadingButton';

const LoadingButtonWrapper = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<LoadingButtonProps>
>(({ children = '', disabled, ...props }, ref) => (
  <LoadingButton
    ref={ref}
    variant="contained"
    aria-label="Loading Button"
    data-testid="loading-button"
    disabled={disabled}
    aria-disabled={disabled}
    {...props}
  >
    <span>{children}</span>
  </LoadingButton>
));

export default LoadingButtonWrapper;
